import React, { Component } from 'react';
import { AuthConsumer } from '../../../auth/AuthContext';
import withStyles from '@material-ui/core/styles/withStyles';
import Cancel from '@material-ui/icons/CancelOutlined';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
// @material-ui/icons
import Close from '@material-ui/icons/Close';
// core components
import Button from 'components/CustomButtons/Button.jsx';

import modalSstyles from 'assets/jss/material-dashboard-pro-react/modalStyle.jsx';
import FormControlLabel from '@material-ui/core/FormControlLabel';
// @material-ui/icons
import Check from '@material-ui/icons/Check';
import Checkbox from '@material-ui/core/Checkbox';

import checkboxStyles from 'assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx';
import tenantRoles from '../../../auth/tenantRoles';

const styles = { ...modalSstyles, ...checkboxStyles };

class CancelOrderButton extends Component {
  state = {
    showModal: false,
    sendConfirmationMail: false,
  };
  showModal = () => {
    this.setState({
      showModal: true,
    });
  };
  hideModal = () => {
    this.setState({ showModal: false });
  };

  onSendConfirmationMailChange = event => {
    this.setState({
      sendConfirmationMail: event.target.checked,
    });
  };

  onConfirm = () => {
    const { onCancelOrder } = this.props;
    onCancelOrder(this.state.sendConfirmationMail, false);
    this.hideModal();
  };
  onConfirmVoucher = () => {
    const { onCancelOrder } = this.props;
    onCancelOrder(this.state.sendConfirmationMail, true);
    this.hideModal();
  };
  render() {
    const {
      classes,
      loading,
      buttonText,
      buttonSize,
      role,
      isOnlyVoucher,
    } = this.props;
    const { sendConfirmationMail, showModal } = this.state;
    return (
      <AuthConsumer>
        {({ isAuthorized }) =>
          isAuthorized(role) ? (
            <React.Fragment>
              <Button
                size={buttonSize}
                color={loading ? undefined : 'warning'}
                onClick={this.showModal}
                disabled={loading}
                justIcon={!buttonText}
              >
                {buttonText ? (
                  <span style={{ marginRight: 10 }}>{buttonText}</span>
                ) : null}
                <Cancel />
              </Button>
              <Dialog
                classes={{
                  root: classes.center,
                  paper: classes.modal,
                }}
                open={showModal}
                keepMounted
                onClose={this.hideModal}
              >
                <DialogTitle
                  id="classic-modal-slide-title"
                  disableTypography
                  className={classes.modalHeader}
                >
                  <Button
                    justIcon
                    className={classes.modalCloseButton}
                    key="close"
                    color="transparent"
                    onClick={this.hideModal}
                  >
                    <Close className={classes.modalClose} />
                  </Button>
                </DialogTitle>
                <DialogContent
                  id="modal-slide-description"
                  className={classes.modalBody}
                  style={{ marginBottom: 20 }}
                >
                  <h5>Wollen sie diese Bestellung wirklich stornieren?</h5>
                  <h6>
                    Bei Teilstornierungen von Pickup-Tickets ist nur die neuste
                    Reservationsnummer (QR-Code) g&uuml;ltig.
                  </h6>
                  <FormControlLabel
                    control={
                      <Checkbox
                        tabIndex={-1}
                        onClick={this.onSendConfirmationMailChange}
                        checked={sendConfirmationMail}
                        checkedIcon={<Check className={classes.checkedIcon} />}
                        icon={<Check className={classes.uncheckedIcon} />}
                        classes={{ checked: classes.checked }}
                      />
                    }
                    classes={{ label: classes.label }}
                    label={'Neues Best\u00e4tigungs-Email senden'}
                  />
                </DialogContent>
                <DialogActions
                  className={
                    classes.modalFooter + ' ' + classes.modalFooterCenter
                  }
                >
                  <Button onClick={this.hideModal}>Abbrechen</Button>
                  {!isOnlyVoucher ? (
                    <Button onClick={this.onConfirm} color="danger">
                      Stornieren
                    </Button>
                  ) : null}
                  <Button onClick={this.onConfirmVoucher} color="danger">
                    Stornieren ohne Payment
                  </Button>
                </DialogActions>
              </Dialog>
            </React.Fragment>
          ) : null
        }
      </AuthConsumer>
    );
  }
}

export default withStyles(styles)(CancelOrderButton);



// WEBPACK FOOTER //
// ./src/views/skidata/components/CancelOrderButton.jsx